import { TableColumnMeta } from "ds/components/Table/types";

import { ActionsColumnId } from "./globalTable";

export enum FilesColumnId {
  EXPAND = "expand",
  NAME = "name",
  DESCRIPTION = "description",
  SECRET = "secret",
  SOURCE = "source",
  CREATED_AT = "createdAt",
  ACTIONS = ActionsColumnId.ACTIONS,
}

export const MOUNTED_FILES_COLUMNS: Record<
  Exclude<FilesColumnId, FilesColumnId.ACTIONS>,
  TableColumnMeta
> = {
  [FilesColumnId.EXPAND]: {
    id: FilesColumnId.EXPAND,
    defaultWidth: 40,
    maxWidth: 40,
    minWidth: 40,
    title: "Expand",
    noHeader: true,
    allowsSorting: false,
    resizable: false,
    canHide: false,
  },
  [FilesColumnId.NAME]: {
    id: FilesColumnId.NAME,
    defaultWidth: 150,
    maxWidth: 300,
    minWidth: 150,
    title: "Name",
    allowsSorting: false,
    resizable: false,
  },
  [FilesColumnId.DESCRIPTION]: {
    id: FilesColumnId.DESCRIPTION,
    defaultWidth: 150,
    maxWidth: 300,
    minWidth: 150,
    title: "Description",
    allowsSorting: false,
    resizable: false,
  },
  [FilesColumnId.SECRET]: {
    id: FilesColumnId.SECRET,
    defaultWidth: 150,
    maxWidth: 300,
    minWidth: 150,
    title: "Secret",
    allowsSorting: false,
    resizable: false,
  },
  [FilesColumnId.SOURCE]: {
    id: FilesColumnId.SOURCE,
    defaultWidth: 150,
    maxWidth: 300,
    minWidth: 150,
    title: "Source",
    allowsSorting: false,
    resizable: false,
  },
  [FilesColumnId.CREATED_AT]: {
    id: FilesColumnId.CREATED_AT,
    defaultWidth: 150,
    maxWidth: 300,
    minWidth: 150,
    title: "Created at",
    allowsSorting: false,
    resizable: false,
  },
};
